import React from 'react';
import { Spin, Select, Button, message, Modal, Input, Card } from 'antd';
import { hashHistory } from 'react-router'

import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';

import CurrentRoleStore from '../../stores/CurrentRoleStore';
import AttendanceCalendar from '../share/AttendanceCalendar';
import ReactQiniuModule from '../../../../lib/ReactQiniuModule';

const Option = Select.Option;

export default class StudentAttendanceRecognitionClassDetailPage extends React.Component {
  constructor(props) {
    super(props);
    console.log(props.location.query)
    this.state = {
      schoolId: props.params.schoolId,
      classId: props.params.classId,
      className: props.location.query.className,
      students: [],
      student: {},
      visible: false,
      loading: false,

      addVisible: false,
      cardNumber: '',

      showCard: false,
      showFace: false
    }

    this.onCancelModal = this.onCancelModal.bind(this)
    this.getAvailableQuotaForUploadingFiles = this.getAvailableQuotaForUploadingFiles.bind(this);
    this.isAllUploadingFileFinished = this.isAllUploadingFileFinished.bind(this);
    this.onFileUploadSuccess = this.onFileUploadSuccess.bind(this);
    this.onFileUploadError = this.onFileUploadError.bind(this);
    this.onFileStartUpload = this.onFileStartUpload.bind(this);

    // 添加卡号
    this.handleCancel = this.handleCancel.bind(this);
    this.editCardNumber = this.editCardNumber.bind(this);
  }

  componentDidMount() {
    DataService.getSchoolSetting(this.state.schoolId).then((res) => {
      let setting = res.gate_setting.student;
      this.setState({
        showCard: setting ? setting.includes('card') : false,
        showFace: setting ? setting.includes('face') : false
      })
    }).catch((error) => {
      console.log(error)
    });

    this.getClassGatePasses(false);
  }

  getClassGatePasses(studentId) {
    DataService.getClassGatePasses({ class_id: this.state.classId }).then((res) => {
      this.setState({
        students: res
      })
      if (studentId) {
        let student = res.find((student) => student.id == studentId);
        this.setState({
          student
        })
      }
    }).catch((error) => {
      console.log(error)
    });
  }

  showImage(studentId) {
    let student = this.state.students.find((student) => student.id == studentId);
    this.setState({
      student,
      visible: true
    })
  }

  uploadImage(studentId) {

  }

  onCancelModal() {
    this.setState({
      student: undefined,
      visible: false
    })
  }

  showEditModal(studentId) {
    let student = this.state.students.find((student) => student.id == studentId);
    this.setState({
      student,
      addVisible: true,
      addCard: (student && student.cards && student.cards.length > 0) ? false : true
    })
  }

  handleCancel() {
    this.setState({
      addVisible: false,
      addCard: false,
      editCardId: undefined,
      cardNumber: '',
      changeStatus: false,
    })
  }

  changeEditCard(cardId) {
    this.setState({
      editCardId: cardId
    })
  }

  editCardNumber(e) {
    this.setState({
      cardNumber: e.target.value,
      changeStatus: true
    })
  }

  updateGateCards(cardId) {
    if (!this.state.changeStatus) {
      this.setState({
        addCard: false,
        editCardId: undefined,
        cardNumber: ''
      })
    } else if (!this.state.cardNumber) {
      message.error('请输入正确的卡号')
    } else {
      let data = {
        card_id: this.state.cardNumber,
        school_id: this.state.schoolId
      }
      DataService.updateGateCards(cardId, data).then((res) => {
        message.success('修改成功');
        this.getClassGatePasses(this.state.student.id);
        this.setState({
          addCard: false,
          changeStatus: false,
          editCardId: undefined,
          cardNumber: ''
        })
      }).catch((error) => {
        if (error && error.errorMessage && error.errorMessage.errors[0].code == 21) {
          message.error('卡号已存在，请重新输入');
        } else {
          message.error('修改失败，请重新输入');
        }
      });
    }
  }

  createGateCards() {
    if (!this.state.changeStatus) {
      this.setState({
        addCard: false,
        editCardId: undefined,
        cardNumber: ''
      })
    } else if (!this.state.cardNumber) {
      message.error('请输入正确的卡号')
    } else {
      let data = {
        person_id: this.state.student.id,
        person_type: 'student',
        card_id: this.state.cardNumber,
        school_id: this.state.schoolId
      }
      DataService.createGateCards(data).then((res) => {
        message.success('添加成功');
        this.getClassGatePasses(this.state.student.id);
        this.setState({
          addCard: false,
          changeStatus: false,
          cardNumber: ''
        })
      }).catch((error) => {
        if (error && error.errorMessage && error.errorMessage.errors[0].code == 21) {
          message.error('卡号已存在，请重新输入');
        } else {
          message.error('添加失败，请重新输入');
        }
      });
    }
  }

  getAvailableQuotaForUploadingFiles() {
    console.log('getAvailableQuotaForUploadingFiles')
    return true
    
  }

  onFileUploadError(fileKey, fileObj, errorKey) {
    this.setState({
      loading: false
    })
    message.error('上传照片失败')
  }

  onFileUploadSuccess(newFileKey, fileName, fileSize, remoteUrl, info, errorKey) {
    let data = {
      photo: remoteUrl,
      width: info.w,
      height: info.h
    }, {student, students} = this.state;
    if (student.gate_pass) {
      DataService.updateGatePasses(student.gate_pass.id, data).then((res) => {
        let newStudent = students.find((item) => item.id == student.id);
        student.gate_pass.photo = data.photo;
        newStudent.gate_pass.photo = data.photo;
        console.log(student)
        this.setState({
          loading: false,
          students,
          student
        })
        message.success('照片替换成功！')
      }).catch((error) => {
        console.log(error)
        if (error && error.errorMessage && error.errorMessage.errors[0].code == 22) {
          Modal.warning({
            title: '提示',
            content: '识别不到人脸(请确认照片中只有一个人脸，人脸尺寸是否过小，是否为正脸',
          });
        } else if (error && error.errorMessage && error.errorMessage.errors[0].code == 23) {
          Modal.warning({
            title: '提示',
            content: '上传的照片尺寸过大，请压缩后重新上传',
          });
        } else if (error && error.errorMessage && error.errorMessage.errors[0].code == 24) {
          Modal.warning({
            title: '提示',
            content: '上传的照片中人脸不够清楚，无法用来人脸识别，请重新拍摄上传',
          });
        } else if (error && error.errorMessage && error.errorMessage.errors[0].code == 25) {
          Modal.warning({
            title: '提示',
            content: '上传的照片中人脸比例太小，无法用来人脸识别，请重新拍摄上传',
          });
        } else if (error && error.errorMessage && error.errorMessage.errors[0].code == 51) {
          Modal.warning({
            title: '提示',
            content: '识别失败，请重试',
          });
        } else {
          message.error('照片替换失败！')
        }
        this.setState({
          loading: false
        })
      });
    } else {
      data.person_type = 'student';
      data.person_id = student.id;
      data.school_id = student.class_record.school_id;
      DataService.createGatePasses(data).then((res) => {
        this.setState({
          loading: false
        })
        message.success('照片上传成功！')
        this.getClassGatePasses(false);
      }).catch((error) => {
        if (error && error.errorMessage && error.errorMessage.errors[0].code == 22) {
          Modal.warning({
            title: '提示',
            content: '识别不到人脸(请确认照片中只有一个人脸，人脸尺寸是否过小，是否为正脸',
          });
        } else if (error && error.errorMessage && error.errorMessage.errors[0].code == 23) {
          Modal.warning({
            title: '提示',
            content: '上传的照片尺寸过大，请压缩后重新上传',
          });
        } else if (error && error.errorMessage && error.errorMessage.errors[0].code == 24) {
          Modal.warning({
            title: '提示',
            content: '上传的照片中人脸不够清楚，无法用来人脸识别，请重新拍摄上传',
          });
        } else if (error && error.errorMessage && error.errorMessage.errors[0].code == 25) {
          Modal.warning({
            title: '提示',
            content: '上传的照片中人脸比例太小，无法用来人脸识别，请重新拍摄上传',
          });
        } else if (error && error.errorMessage && error.errorMessage.errors[0].code == 51) {
          Modal.warning({
            title: '提示',
            content: '识别失败，请重试',
          });
        } else {
          message.error('照片上传失败！')
        }
        this.setState({
          loading: false
        })
      });
      
    }
  }

  onFileStartUpload() {
    if (!this.state.loading) {
      this.setState({
        loading: true
      })
      return true;
    } else {
      return false
    }
  }

  isAllUploadingFileFinished() {
    console.log('isAllUploadingFileFinished')
  }

  uploadStudentRecognition(studentId) {
    let student = this.state.students.find((student) => student.id == studentId);
    this.setState({
      student,
    })
    this.uploadModuleObj.onClick();
  }

  // replaceStudentRecognition(studentId) {
  //   this.uploadStudentRecognition(studentId)
  // }
  

  _imageViewModal() {
    let student = this.state.student;
    return (
      <div className="image-view-modal">
        <div className="image-view-modal-mask" onClick={this.onCancelModal}></div>
        <div className="photos-wrapper">
          <div className="face-recognition-photos-view">
            <span className="photo-view-span"><img src={(student && student.gate_pass && student.gate_pass.photo) ? student.gate_pass.photo : ''} className="photo-card-img" /></span>
            <div className="photo-btn"><Button type="primary" onClick={this.uploadStudentRecognition.bind(this, student.id)}>替换照片</Button></div>
          </div>
          <div className="image-view-modal-cancel" onClick={this.onCancelModal} ></div>
        </div>
      </div>
    )
  }

  _addCardModal() {
    let { student, editCardId, addVisible, addCard} = this.state;
    return (
      <Modal
        visible={addVisible}
        title={student.full_name + " 门禁卡"}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        footer={null}
        wrapClassName="add-card-modal"
      >
        {student.cards ? student.cards.map((card, index) => {
          if (card.id == editCardId) {
            return (<div className="edit-name" key={card.id}>
              <Input addonBefore={<span className="card-title">门禁卡{index + 1}</span>} value={this.state.changeStatus ? this.state.cardNumber : card.card_id} onChange={this.editCardNumber} addonAfter={<span className="submit-btn" onClick={this.updateGateCards.bind(this, card.id)}>{this.state.changeStatus ? '确认' : '取消'}</span>} type="number" />
            </div>)
          } else {
            return (
              <div className="edit-name" key={card.id}>
                <div className="card-container">
                  <div className="card-name">门 禁 卡 {index + 1}</div>
                  <div className="card-number">{card.card_id}</div>
                  {(editCardId || addCard) ? '' : <div className="card-btn" onClick={this.changeEditCard.bind(this, card.id)}>修 改</div>}
                </div>
              </div>
            )
          }
        }) : ''}
        
        {editCardId ? '' : (addCard ? <div className="edit-name">
          <Input addonBefore={<span className="card-title">新增卡号</span>} value={this.state.cardNumber} onChange={this.editCardNumber} addonAfter={<span className="submit-btn" onClick={this.createGateCards.bind(this)}>{this.state.changeStatus ? '确认' : '取消'}</span>} type="number" />
        </div> : <div className="edit-name"><span onClick={() => this.setState({ addCard: true })} className="add-card-btn">+添加新卡</span></div>)}
      </Modal>
    )
  }

  _reactQiniuModule() {
    return (<ReactQiniuModule
      ref={(uploadModule) => { this.uploadModuleObj = uploadModule; }}
      // className=""
      onSuccess={this.onFileUploadSuccess}
      onError={this.onFileUploadError}
      onStartPermit={this.onFileStartUpload}
      isAllFinish={this.isAllUploadingFileFinished}
      getUploadQuota={this.getAvailableQuotaForUploadingFiles}
      allowUploadFileTypes={ReactQiniuModule.getFileCategories.ALL}
      allowUploadFileSize={10}
      multiple={false}>
      
    </ReactQiniuModule>)
  }

  render() {
    let { showFace, showCard} = this.state;
    return (
      <div className="student-attendance-recognition-page">
        <Spin tip="照片上传中..." spinning={this.state.loading} className="student-attendance-recognition-spin">
          <div className="page-header">
            {this.state.className}
          </div>
          <div className="images-container">
            {this.state.students.map((student) => <Card className="card" key={student.id}>
              <div className="student-face-recognition">
                {showFace ? ((student.gate_pass && student.gate_pass.photo) ? <img src={student.gate_pass.photo} className="face-recognition" onClick={this.showImage.bind(this, student.id)} /> :
                <div onClick={this.uploadStudentRecognition.bind(this, student.id)} className="upload-face-recognition"><div className="upload-label">点击上传</div></div>) : ''}
                <div className="student-name">{student.full_name}</div>
                {(showCard) ? <div className="card-container">卡片数量: {student.cards ? student.cards.length : 0} <span className="add-card-btn" onClick={this.showEditModal.bind(this, student.id)}>{(student.cards && student.cards.length > 0) ? '查看' : '添加'}</span></div> : ''}
              </div></Card>)}
          </div>
          
        </Spin>
        {this._reactQiniuModule()}
        {this.state.visible ? this._imageViewModal() : '' }
        {this.state.addVisible ? this._addCardModal() : ''}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/attendance/StudentAttendanceRecognitionClassDetailPage.jsx